import { FormPasswordTextField } from "@ea/ui/components/forms/FormPasswordTextField";
import { FormTextField } from "@ea/ui/components/forms/FormTextField";
import { DataTestIds } from "@ea/ui/dataTestIds";
import { useTranslations } from "@ea/ui/translations/useTranslations";
import { WarningOutlinedIcon } from "@ea/ui/icons/WarningOutlinedIcon";
import { LoginAlert } from "./LoginPage.styles";

export const LoginFormFields = ({ serverError }: { serverError?: string }) => {
  const { t } = useTranslations("Login");
  return (
    <>
      <FormTextField
        dataTestid={DataTestIds.FORM_INPUT_USERNAME}
        name="username"
        label={t("username")}
        required
      />
      <FormPasswordTextField
        name="password"
        label={t("password")}
        dataTestid={DataTestIds.FORM_INPUT_PASSWORD}
      />

      {serverError && (
        <LoginAlert>
          <WarningOutlinedIcon />
          {serverError}
        </LoginAlert>
      )}
    </>
  );
};
